import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
    IAcademicSchedulingPayload,
    IInitialStateAcademicScheduling
} from "../types";

import {
    GetAcademicScheduling,
    GetDeleteAcademicScheduling
} from "../store/thunk";


const initialState: IInitialStateAcademicScheduling = {
    academicScheduling: [],
    selectedAcademicSchedulingIDs: [],
    academicSchedulingRestore: [],
    isLoadingAcademicScheduling: false,
    isViewAcademicSchedulingRestore: false
}

const academicSchedulingSlice = createSlice({
    name: "academicScheduling",
    initialState,
    reducers: {
        setAcademicScheduling: (state, action: PayloadAction<IAcademicSchedulingPayload[]>) => {
            state.academicScheduling = action.payload
        },

        deletedAcademicScheduling: (state, action: PayloadAction<number>) => {
            const updateData = action.payload;
            state.academicScheduling = state.academicScheduling.filter((elem) => elem.id !== updateData)
        },
        updateAcademicScheduling: (state, action: PayloadAction<IAcademicSchedulingPayload>) => {
            const updateData = action.payload;
            state.academicScheduling = state.academicScheduling.map((elem: IAcademicSchedulingPayload) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData
                    };
                }
                return elem;
            });
        },
        setAcademicSchedulingRestore: (state, action) => {
            state.academicSchedulingRestore = action.payload;
        },

        deletedRestoreAcademicScheduling: (state, action) => {
            const id = action.payload
            state.academicSchedulingRestore = state.academicSchedulingRestore.filter(
                (elem) => elem.id !== id
            );
        },
        setIsViewAcademicSchedulingRestore: (state) => {

            state.isViewAcademicSchedulingRestore = !state.isViewAcademicSchedulingRestore;
        },
        setSelectedAcademicSchedulingIDs: (state, action) => {
            state.selectedAcademicSchedulingIDs = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(GetAcademicScheduling.pending, state => {
            state.isLoadingAcademicScheduling = true
        }).addCase(GetAcademicScheduling.fulfilled, state => {
            state.isLoadingAcademicScheduling = false
        }).addCase(GetAcademicScheduling.rejected, state => {
            state.isLoadingAcademicScheduling = false
        })
            .addCase(GetDeleteAcademicScheduling.pending, state => {
                state.isLoadingAcademicScheduling = true
            }).addCase(GetDeleteAcademicScheduling.fulfilled, state => {
            state.isLoadingAcademicScheduling = false
        }).addCase(GetDeleteAcademicScheduling.rejected, state => {
            state.isLoadingAcademicScheduling = false
        })
    }

})

export const {
    setAcademicScheduling,
    deletedAcademicScheduling,
    updateAcademicScheduling,
    setAcademicSchedulingRestore,
    deletedRestoreAcademicScheduling,
    setIsViewAcademicSchedulingRestore,
    setSelectedAcademicSchedulingIDs
} = academicSchedulingSlice.actions;

export default academicSchedulingSlice